import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import api from "../../config.json";
import CountUp from "react-countup";
import moment from "moment";
import Gauge from "react-gauge-component";

// localStorage key used to persist the selected Equipment Group filter
const EQUIP_GROUP_FILTER_KEY = "dashboardEquipmentGroupFilter";

// The upper section of the dashboard can be viewed either as a single plant wide
// number ("aggregated") or split per equipment type ("byType"). The toggle itself lives
// in the Navbar row next to the Equipment Group filter and arrives here as the
// upperViewMode prop; the localStorage key below is only the fallback used when this
// dashboard is rendered without that Navbar row.
const VIEW_MODE_KEY_PREFIX = "dashboardUpperViewMode_";
const AGGREGATED = "aggregated";
const BY_TYPE = "byType";

// Chip colors are assigned by the position of the equipment type in the shared type
// order, so a type keeps the same color under every card.
const TYPE_CHIP_COLORS = [
  "#2f54eb",
  "#389e0d",
  "#722ed1",
  "#c41d7f",
  "#d46b08",
  "#08979c",
  "#5b8c00",
  "#cf1322",
];

const DashBoardCustom = ({ spncolorconfig, getCurrentData, equipmentGroupFilter, filterStorageKey = EQUIP_GROUP_FILTER_KEY, upperViewMode }) => {
  const [MachineRun, setMachineRun] = useState(null);
  const [Strokes, setStrokes] = useState(null);
  const [RunningSPM, setRunningSPM] = useState({ RunningSPM: 0 });
  const [AvgSPM, setAvgSPM] = useState({ AvgSPM: 0 });
  const [StrokesDate, setStrokesDate] = useState(null);
  const [equipmentColor, setEquipmentColor] = useState({ EquipmentColor: [] });
  const [downtimeBreakdown, setDowntimeBreakdown] = useState(null);
  const [hoveredBar, setHoveredBar] = useState(null);
  // Fallback for render sites that don't supply upperViewMode (no Navbar toggle).
  const [storedViewMode] = useState(() => {
    try {
      return localStorage.getItem(VIEW_MODE_KEY_PREFIX + filterStorageKey) === BY_TYPE
        ? BY_TYPE
        : AGGREGATED;
    } catch (e) {
      return AGGREGATED;
    }
  });
  const viewMode =
    upperViewMode === AGGREGATED || upperViewMode === BY_TYPE
      ? upperViewMode
      : storedViewMode;


  // useEffect(() => {
  //   // Function to call the API
  //   // axios.put(api.dataEntryUrl + 'GetPlantSPMDashboard', { name: 'MachineRun' })
  //   //   .then((response) => {
  //   //     console.log(response, "success response for the dashboard");
  //   //     if (response.status === 200) {
  //   //       getCurrentData({ CurrentDate: response.data.CurrentDate })
  //   //       setMachineRun(response.data.MachineRun);
  //   //     }
  //   //   })
  //   //   .catch(error => console.error('Error:', error));

  //   // Replace the URL with your API endpoint
  //   axios
  //     .put(api.dataEntryUrl + "GetPlantSPMDashboard", { name: "Stroke" })
  //     .then((response) => {
  //       console.log(response, "success response for the dashboard");
  //       if (response.status === 200) {
  //         getCurrentData({ CurrentDate: response.data.CurrentDate });
  //         setStrokes(response.data);
  //         setStrokesDate(response.data.Date);
  //       }
  //     })
  //     .catch((error) => console.error("Error:", error));

  //   axios
  //     .put(api.dataEntryUrl + "GetPlantSPMDashboard", { name: "AvgSPM" })
  //     .then((response) => {
  //       console.log(response, "success response for the dashboard spm");
  //       if (response.status === 200) {
  //         getCurrentData({ CurrentDate: response.data.CurrentDate });
  //         setAvgSPM(response.data);
  //       }
  //     })
  //     .catch((error) => console.error("Error:", error));

  //   axios
  //     .put(api.dataEntryUrl + "GetPlantSPMDashboard", { name: "RunningSPM" })
  //     .then((response) => {
  //       console.log(response, "success response for the dashboard");
  //       if (response.status === 200) {
  //         getCurrentData({ CurrentDate: response.data.CurrentDate });
  //         setRunningSPM(response.data);
  //       }
  //     })
  //     .catch((error) => console.error("Error:", error));

  //   axios
  //     .put(api.dataEntryUrl + "GetPlantSPMDashboard", { name: "EquipmentColor" })
  //     .then((response) => {
  //       console.log(response, "success response for the dashboard");
  //       if (response.status === 200) {
  //         getCurrentData({ CurrentDate: response.data.CurrentDate });
  //         setEquipmentColor(response.data);
  //       }
  //     })
  //     .catch((error) => console.error("Error:", error));
  // }, []);

  // useEffect(() => {
  //   // Function to call the API
  //   const callApi = (interval, data) => {
  //     console.log(
  //       `Calling API after ${interval / 1000} seconds with data:`,
  //       data
  //     );
  //     // Replace the URL with your API endpoint
  //     axios
  //       .put(api.dataEntryUrl + "GetPlantSPMDashboard", { name: data })
  //       .then((response) => {
  //         console.log(response, "success response for the dashboard");
  //         if (response.status === 200) {
  //           if (data === "MachineRun") {
  //             getCurrentData({ CurrentDate: response.data.CurrentDate });
  //             setMachineRun(response.data.MachineRun);
  //           }
  //           if (data === "Strokes") {
  //             getCurrentData({ CurrentDate: response.data.CurrentDate });
  //             setStrokes(response.data);
  //             setStrokesDate(response.data.Date);
  //           }
  //           if (data === "AvgSPM") {
  //             getCurrentData({ CurrentDate: response.data.CurrentDate });
  //             setAvgSPM(response.data);
  //           }
  //           if (data === "RunningSPM") {
  //             getCurrentData({ CurrentDate: response.data.CurrentDate });
  //             setRunningSPM(response.data);
  //           }
  //           if (data === "EquipmentColor") {
  //             getCurrentData({ CurrentDate: response.data.CurrentDate });
  //             setEquipmentColor(response.data);
  //           }
  //         }
  //       })
  //       .catch((error) => console.error("Error:", error));
  //   };

  //   // Set intervals to call API independently
  //   const intervals = [
  //     // { interval: 180000, data: 'MachineRun' },  // 5s
  //     { interval: 120000, data: "Stroke" }, // 10s
  //     { interval: 210000, data: "AvgSPM" },
  //     { interval: 180000, data: "RunningSPM" },
  //     { interval: 150000, data: "EquipmentColor" }, // 15s
  //   ];

  //   // Store the interval IDs so they can be cleared if needed
  //   const intervalIds = intervals.map((call) => {
  //     return setInterval(
  //       () => callApi(call.interval, call.data),
  //       call.interval
  //     );
  //   });

  //   // Cleanup function to clear intervals when component unmounts
  //   return () => {
  //     intervalIds.forEach((id) => clearInterval(id));
  //   };
  // }, []);


  const callApi = (data) => {
    // Always read the latest selected groups from localStorage so recursive
    // scheduled calls never use a stale value from a closure.
    let groups = [];
    try {
      const raw = localStorage.getItem(filterStorageKey);
      const parsed = raw ? JSON.parse(raw) : [];
      groups = Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      groups = [];
    }
    const payload = { name: data };
    // Empty selection means "All" -> no filter sent
    if (groups.length > 0) {
      payload.EquipmentGroup = groups;
    }

    // Replace the URL with your API endpoint
    axios
      .put(api.dataEntryUrl + "GetPlantSPMDashboard", payload)
      .then((response) => {
        console.log(response, "success response for the dashboard");
        if (response.status === 200) {
          if (data === "MachineRun") {
            getCurrentData({ CurrentDate: response.data.CurrentDate });
            setMachineRun(response.data.MachineRun);
          }
          if (data === "Stroke") {
            getCurrentData({ CurrentDate: response.data.CurrentDate });
            setStrokes(response.data);
            setStrokesDate(response.data.Date);
          }
          if (data === "AvgSPM") {
            getCurrentData({ CurrentDate: response.data.CurrentDate });
            setAvgSPM(response.data);
          }
          if (data === "RunningSPM") {
            getCurrentData({ CurrentDate: response.data.CurrentDate });
            setRunningSPM(response.data);
          }
          if (data === "EquipmentColor") {
            getCurrentData({ CurrentDate: response.data.CurrentDate });
            setEquipmentColor(response.data);
          }
          if (data === "ShiftDowntimeBreakdown") {
            setDowntimeBreakdown(response.data);
          }
        }
      })
      .catch((error) => console.error("Error:", error));
  };

    useEffect(() => {
      // Initial fetch of data
      callApi("Stroke")
      callApi("AvgSPM")
      callApi("RunningSPM")
      callApi("EquipmentColor")
      callApi("ShiftDowntimeBreakdown")
      //     { interval: 120000, data: "Stroke" }, // 10s
      //     { interval: 210000, data: "AvgSPM" },
      //     { interval: 180000, data: "RunningSPM" },
      //     { interval: 150000, data: "EquipmentColor" },
  
      // Schedule the next API call
      // scheduleNextCall re-arms itself, so keep the latest timer id in a handle unmount can cancel.
      const timer = { id: null, cancelled: false };
      scheduleNextCall(timer);
  
      // Clean up the timer when component unmounts
      return () => {
        timer.cancelled = true;
        clearTimeout(timer.id);
      };
    }, []);
  
  
  
  
    function scheduleNextCall(timer) {
      const now = new Date();
      let delay;
  
      // Calculate delay until the next desired time (next multiple of 5 minutes)
      const minutes = now.getMinutes();
      const nextMultiple = Math.ceil(minutes / 5) * 5; // Calculate the next multiple of 5 minutes
      const targetTime = new Date(now);
      targetTime.setMinutes(nextMultiple, 0, 0); // Set the target time to the next multiple of 5 minutes
  
      if (targetTime <= now) {
        targetTime.setMinutes(targetTime.getMinutes() + 5); // If target time is past, schedule for the next multiple of 5 minutes
      }
  
      delay = targetTime.getTime() - now.getTime();
  
      // Schedule the next API call recursively
      timer.id = setTimeout(function () {
        if (timer.cancelled) return;
        callApi("Stroke")
        callApi("AvgSPM")
        callApi("RunningSPM")
        callApi("EquipmentColor")
        scheduleNextCall(timer);
      }, delay);
    }

  const refetchDashboard = () => {
    callApi("Stroke");
    callApi("AvgSPM");
    callApi("RunningSPM");
    callApi("EquipmentColor");
    callApi("ShiftDowntimeBreakdown");
  };

  // Refetch the dashboard whenever the Equipment Group filter (controlled from
  // the Navbar header) changes. Skip the very first run since the mount effect
  // above already performs the initial fetch.
  const isFirstFilterRun = useRef(true);
  useEffect(() => {
    if (isFirstFilterRun.current) {
      isFirstFilterRun.current = false;
      return;
    }
    refetchDashboard();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(equipmentGroupFilter || [])]);

  const getPercentage = () => {
    const equipColors = { ...equipmentColor };
    let per = 0;

    const greens = equipColors.EquipmentColor.filter((x) => x.Color == "green");
    per = (greens.length / equipColors.EquipmentColor.length) * 100;
    if (isNaN(per) && !isFinite(per)) {
      per = 0;
    }
    return per.toFixed(1);
  };

  const getRunningCount = () => {
    return equipmentColor.EquipmentColor.filter(x => x.Color === "green").length;
  };

  const getTotalCount = () => {
    return equipmentColor.EquipmentColor.length;
  };

  const getBreakdownMachines = () => {
    return equipmentColor.EquipmentColor.filter(x => x.Color !== "green").map(x => x.Equipment);
  };

  const isLightColor = (hex) => {
    if (!hex) return false;
    const named = { white: "#ffffff", yellow: "#ffff00", lightyellow: "#ffffe0", lightgreen: "#90ee90", lightblue: "#add8e6", pink: "#ffc0cb", beige: "#f5f5dc", ivory: "#fffff0", lavender: "#e6e6fa", cyan: "#00ffff", aqua: "#00ffff", aliceblue: "#f0f8ff", honeydew: "#f0fff0", mintcream: "#f5fffa", snow: "#fffafa", ghostwhite: "#f8f8ff", floralwhite: "#fffaf0", linen: "#faf0e6", oldlace: "#fdf5e6", seashell: "#fff5ee", cornsilk: "#fff8dc", lemonchiffon: "#fffacd", lightskyblue: "#87cefa", lightcyan: "#e0ffff", palegreen: "#98fb98", khaki: "#f0e68c", gold: "#ffd700", orange: "#ffa500" };
    let c = hex.trim().toLowerCase();
    if (named[c]) c = named[c];
    c = c.replace("#", "");
    if (c.length === 3) c = c[0] + c[0] + c[1] + c[1] + c[2] + c[2];
    if (c.length < 6) return false;
    const r = parseInt(c.substr(0, 2), 16);
    const g = parseInt(c.substr(2, 2), 16);
    const b = parseInt(c.substr(4, 2), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.45;
  };

  // One shared ordering of equipment types across all four cards, taken from whichever
  // responses have already arrived. Types missing from a card simply have no chip.
  const equipmentTypeOrder = (() => {
    const order = [];
    [
      Strokes && Strokes.ByType,
      equipmentColor && equipmentColor.ByType,
      AvgSPM && AvgSPM.ByType,
      RunningSPM && RunningSPM.ByType,
    ].forEach((list) => {
      (list || []).forEach((one) => {
        if (one && one.EquipmentType && order.indexOf(one.EquipmentType) === -1) {
          order.push(one.EquipmentType);
        }
      });
    });
    return order;
  })();

  const getTypeColor = (type) => {
    const index = equipmentTypeOrder.indexOf(type);
    return TYPE_CHIP_COLORS[(index < 0 ? 0 : index) % TYPE_CHIP_COLORS.length];
  };

  const strokeChips = () =>
    ((Strokes && Strokes.ByType) || []).map((one) => ({
      type: one.EquipmentType,
      value: Number(one.Stroke || 0).toLocaleString(),
    }));

  const machineRunChips = () =>
    ((equipmentColor && equipmentColor.ByType) || []).map((one) => ({
      type: one.EquipmentType,
      value: one.Running || 0,
    }));

  const spmChips = (source, field) =>
    ((source && source.ByType) || []).map((one) => ({
      type: one.EquipmentType,
      value: Number(one[field] || 0).toFixed(1),
    }));

  // Renders the "By Equipment Type" chip strip shown under a card's headline number.
  // Returns nothing in aggregated mode. When the card has no breakdown it says so
  // rather than rendering nothing, since a silently blank strip is indistinguishable
  // from the API server still serving a build without the ByType field.
  const renderTypeBreakdown = (chips) => {
    if (viewMode !== BY_TYPE) return null;
    if (!chips || chips.length === 0) {
      return (
        <div
          style={{
            width: "100%",
            marginTop: 12,
            paddingTop: 10,
            borderTop: "1px solid #e9ecef",
            fontSize: "0.8rem",
            fontWeight: 600,
            color: "#8c8c8c",
            textAlign: "center",
          }}
        >
          Equipment type breakdown not available
        </div>
      );
    }
    return (
      <div
        style={{
          width: "100%",
          marginTop: 12,
          paddingTop: 10,
          borderTop: "1px solid #e9ecef",
        }}
      >
        <div
          style={{
            fontSize: "0.72rem",
            fontWeight: 700,
            letterSpacing: "0.06em",
            textTransform: "uppercase",
            color: "#8c8c8c",
            textAlign: "center",
            marginBottom: 8,
          }}
        >
          By Equipment Type
        </div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 8,
            justifyContent: "center",
          }}
        >
          {chips.map((chip) => (
            <div
              key={chip.type}
              style={{
                minWidth: 96,
                background: "#f7f8fa",
                borderRadius: 6,
                padding: "6px 12px",
                textAlign: "center",
              }}
            >
              <span
                style={{
                  display: "inline-block",
                  background: getTypeColor(chip.type),
                  color: "#fff",
                  borderRadius: 4,
                  padding: "1px 8px",
                  fontSize: "0.7rem",
                  fontWeight: 700,
                  marginBottom: 4,
                }}
              >
                {chip.type}
              </span>
              <div
                style={{
                  fontSize: "1.5rem",
                  fontWeight: 700,
                  color: "#1a1a1a",
                  lineHeight: 1.1,
                }}
              >
                {chip.value}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const isByType = viewMode === BY_TYPE;
  // In "By Equipment Type" the chips need room, so the cards grow instead of being
  // pinned to the fixed height the aggregated view uses.
  const cardSizing = (fixedHeight) =>
    isByType
      ? { height: "auto", minHeight: `${fixedHeight}px` }
      : { height: `${fixedHeight}px` };
  const headlineFontSize = isByType ? "3.4rem" : "5vw";
  // The long-breakdown list shares the Machine Running card with the type chips, so it
  // stands down while the "By Equipment Type" view has that space.
  const showLongDownList =
    !isByType &&
    downtimeBreakdown &&
    downtimeBreakdown.LongDownMachines &&
    downtimeBreakdown.LongDownMachines.length > 0;

  const formatDuration = (seconds) => {
    if (!seconds || seconds <= 0) return "0m";
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.round((seconds % 3600) / 60);
    if (hrs > 0) return `${hrs}h ${mins}m`;
    return `${mins}m`;
  };

  return (
    <div>
      <div className="row ml-0">
        <div
          style={cardSizing(255)}
          className="grid-item shadow card col-lg-6 "
        >
          <div className="d-flex flex-column" style={{ height: "100%", justifyContent: "center", alignItems: "center", textAlign: "center", padding: "12px 16px" }}>
            <h2  style={{ fontSize: "1.6rem", fontWeight: "700", margin: 0, color:'black', textAlign: "center"}}>
              Total Strokes Of Shift <br />
              {Strokes &&
                Strokes.Shift &&
                StrokesDate &&
                moment(StrokesDate).format("DD-MMMM-YY") +
                  "  ( " +
                  Strokes.Shift +
                  " )"}
            </h2>
            <div style={{ fontSize: headlineFontSize, fontWeight: "700", textAlign: "center" }}>
              <CountUp
                end={Strokes && Strokes.Stroke && (Strokes.Stroke ?? 0)}
                duration={4}
              />
            </div>
            {renderTypeBreakdown(strokeChips())}
          </div>
        </div>
        <div
          style={{ ...cardSizing(255), overflow: "hidden" }}
          className="grid-item shadow card col-lg-6"
        >
          {/* The long-breakdown list is pinned to the right edge, so reserve room for it
              instead of letting the centred figures slide underneath it. */}
          <div style={{ height: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "12px 20px", paddingRight: showLongDownList ? 320 : 20, position: "relative" }}>
            <div style={{ textAlign: "center" }}>
              <h2 style={{ fontSize: "1.4rem", fontWeight: "700", margin: 0, color: 'black' }}>Machine Running</h2>
              <div style={{ fontSize: headlineFontSize, fontWeight: "700", lineHeight: 1.2 }}>
                {getRunningCount()}
              </div>
              <div style={{ fontSize: "1.3rem", fontWeight: "600", color: "#555" }}>
                ({getTotalCount() > 0 ? Math.round((getRunningCount() / getTotalCount()) * 100) : 0}%)
              </div>
            </div>
            {renderTypeBreakdown(machineRunChips())}
            {showLongDownList && (
              <div style={{ position: "absolute", right: 14, top: "50%", transform: "translateY(-50%)", maxHeight: "220px", overflowY: "auto", textAlign: "left" }}>
                <span style={{ fontSize: "2rem", fontWeight: "700", color: "#d32f2f", display: "block", marginBottom: 8 }}>Breakdown (&gt;24h):</span>
                {downtimeBreakdown.LongDownMachines.map((m, i) => (
                  <div key={i} style={{ fontSize: "1.9rem", fontWeight: "700", color: "#333", lineHeight: 1.6 }}>{m}</div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="row ml-0">
        <div
          style={cardSizing(180)}
          className="grid-item shadow card col-lg-6"
        >
          <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", height: "100%", paddingTop: "32px", paddingBottom: "12px", paddingLeft: "20px", paddingRight: "20px", alignItems: "center", textAlign: "center" }}>
            <h2 style={{ fontSize: "1.3rem", fontWeight: "700", margin: 0, color: "black", textAlign: "center" }}>
              Running SPM{" "}
              {AvgSPM &&
                AvgSPM.From &&
                "( " + moment(AvgSPM.From).format("MMMM") + " )"}
            </h2>
            <div
              style={{
                fontSize: headlineFontSize,
                fontWeight: "700",
                color: `${
                  RunningSPM &&
                  RunningSPM.RunningSPM &&
                  spncolorconfig &&
                  spncolorconfig.SPMDisplayColorConfig &&
                  (Number(RunningSPM.RunningSPM) <=
                  spncolorconfig.SPMDisplayColorConfig.lowVal
                    ? "red"
                    : Number(AvgSPM.AvgSPM) <=
                      spncolorconfig.SPMDisplayColorConfig.highVal
                    ? "#FF7518"
                    : "green")
                } `,
              }}
            >
              <CountUp
                decimals={1}
                decimal="."
                decimalPlaces={1}
                end={
                  RunningSPM &&
                  RunningSPM.RunningSPM &&
                  (Number(RunningSPM.RunningSPM) ?? 0)
                }
                duration={4}
              />
            </div>
            {renderTypeBreakdown(spmChips(RunningSPM, "RunningSPM"))}
          </div>
        </div>
        <div
          style={cardSizing(180)}
          className="grid-item shadow card col-lg-6"
        >
          <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", height: "100%", paddingTop: "32px", paddingBottom: "12px", paddingLeft: "20px", paddingRight: "20px", alignItems: "center", textAlign: "center" }}>
            <h2 style={{ fontSize: "1.3rem", fontWeight: "700", margin: 0, color: "black", textAlign: "center" }}>
              Average SPM{" "}
              {AvgSPM &&
                AvgSPM.From &&
                "( " + moment(AvgSPM.From).format("MMMM") + " )"}
            </h2>
            <div
              style={{
                fontSize: headlineFontSize,
                fontWeight: "700",
                color: `${
                  AvgSPM &&
                  AvgSPM.AvgSPM &&
                  spncolorconfig &&
                  spncolorconfig.SPMDisplayColorConfig &&
                  (Number(AvgSPM.AvgSPM) <=
                  spncolorconfig.SPMDisplayColorConfig.lowVal
                    ? "red"
                    : Number(AvgSPM.AvgSPM) <=
                      spncolorconfig.SPMDisplayColorConfig.highVal
                    ? "#FF7518"
                    : "green")
                } `,
              }}
            >
              <CountUp
                decimals={1}
                decimal="."
                decimalPlaces={1}
                end={AvgSPM && AvgSPM.AvgSPM && (Number(AvgSPM.AvgSPM) ?? 0)}
                duration={4}
              />
            </div>
            {renderTypeBreakdown(spmChips(AvgSPM, "AvgSPM"))}
          </div>
        </div>
      </div>
      {downtimeBreakdown && (
        <div className="row ml-0 mt-2">
          <div className="shadow card col-lg-12 p-3">
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6, flexWrap: "wrap", gap: 6 }}>
              <h4 style={{ margin: 0, fontWeight: "700", color: "black", fontSize: "1.3rem" }}>
                Shift: {downtimeBreakdown.Shift} ({moment(downtimeBreakdown.ShiftStart).format("HH:mm")} - {moment(downtimeBreakdown.ShiftEnd).format("HH:mm")})
              </h4>
              <div style={{ display: "flex", gap: 20, alignItems: "center" }}>
                <span style={{ fontSize: "1.6rem", fontWeight: "700", color: "#2e7d32" }}>
                  Total Run: {formatDuration(downtimeBreakdown.TotalRunTime)}
                </span>
                <span style={{ fontSize: "1.6rem", fontWeight: "600", color: "#1e3a5f" }}>
                  Elapsed: {formatDuration(downtimeBreakdown.ElapsedMinutes * 60)}
                </span>
              </div>
            </div>
            {(() => {
              const planned = downtimeBreakdown.PlannedDowntime || [];
              const unplanned = downtimeBreakdown.UnplannedDowntime || [];
              const runTime = downtimeBreakdown.TotalRunTime || 0;

              const bars = [];
              bars.push({ key: "Runtime", name: "Machine Running", color: "#2e7d32", duration: runTime, type: "Runtime" });
              planned.forEach((p, i) => {
                bars.push({ key: `P_${i}`, name: p.Category, color: p.Color || "#ff9800", duration: p.Duration || 0, type: "Planned" });
              });
              unplanned.forEach((u, i) => {
                bars.push({ key: `U_${i}`, name: u.Category, color: u.Color || "#c62828", duration: u.Duration || 0, type: "Unplanned" });
              });

              const totalShiftTime = bars.reduce((s, b) => s + b.duration, 0);
              const plannedTotal = planned.reduce((s, p) => s + (p.Duration || 0), 0);
              const unplannedTotal = unplanned.reduce((s, u) => s + (u.Duration || 0), 0);

              // normalize widths so bar + markers are always in sync
              const rawWidths = bars.map(b => totalShiftTime ? (b.duration / totalShiftTime) * 100 : 0);
              const clampedWidths = rawWidths.map(w => Math.max(w, 0.5));
              const clampedTotal = clampedWidths.reduce((s, w) => s + w, 0);
              const normWidths = clampedWidths.map(w => (w / clampedTotal) * 100);

              const runtimeNormPct = normWidths[0];
              const plannedNormPct = normWidths.slice(1, 1 + planned.length).reduce((s, w) => s + w, 0);
              const unplannedNormPct = normWidths.slice(1 + planned.length).reduce((s, w) => s + w, 0);

              const hoveredBarData = hoveredBar !== null ? bars[hoveredBar] : null;

              const sortedPlanned = [...planned].sort((a, b) => (b.Duration || 0) - (a.Duration || 0));
              const sortedUnplanned = [...unplanned].sort((a, b) => (b.Duration || 0) - (a.Duration || 0));

              return (
                <div style={{ position: "relative", paddingTop: 30 }}>
                  {hoveredBarData && (
                    <div style={{ position: "absolute", top: 0, left: "50%", transform: "translateX(-50%)", background: "#222", color: "#fff", padding: "10px 18px", borderRadius: 8, fontSize: "1.1rem", fontWeight: 500, whiteSpace: "nowrap", zIndex: 10, boxShadow: "0 4px 12px rgba(0,0,0,0.3)", pointerEvents: "none" }}>
                      <strong>{hoveredBarData.name}</strong>  {formatDuration(hoveredBarData.duration)} <span style={{ opacity: 0.7 }}>({hoveredBarData.type})</span>
                    </div>
                  )}
                  <div style={{ display: "flex", width: "100%", height: 55, borderRadius: 6, overflow: "hidden", border: "1px solid #dee2e6" }}>
                    {bars.map((b, i) => (
                      <div
                        key={b.key}
                        onMouseEnter={() => setHoveredBar(i)}
                        onMouseLeave={() => setHoveredBar(null)}
                        style={{
                          width: `${normWidths[i]}%`,
                          height: "100%",
                          background: b.color,
                          cursor: "pointer",
                          opacity: hoveredBar !== null && hoveredBar !== i ? 0.7 : 1,
                          transition: "opacity 0.2s",
                        }}
                      />
                    ))}
                  </div>
                  {/* Category markers below bar */}
                  {(planned.length > 0 || unplanned.length > 0) && (
                  <div style={{ display: "flex", width: "100%", marginTop: 2 }}>
                    {runtimeNormPct > 0 && (
                      <div style={{ width: `${runtimeNormPct}%`, textAlign: "center", fontSize: "0.85rem", fontWeight: 700, color: "#2e7d32", padding: "4px 0", overflow: "hidden", boxSizing: "border-box" }}>
                        <div style={{ borderTop: "3px solid #2e7d32", marginLeft: 2, marginRight: 2, marginBottom: 4 }} />
                        <span>Running ({formatDuration(runTime)})</span>
                      </div>
                    )}
                    {planned.length > 0 && (
                      <div style={{ width: `${plannedNormPct}%`, textAlign: "center", fontSize: "0.85rem", fontWeight: 700, color: "#e65100", padding: "4px 0", overflow: "hidden", boxSizing: "border-box" }}>
                        <div style={{ borderTop: "3px solid #e65100", marginLeft: 2, marginRight: 2, marginBottom: 4 }} />
                        <span>Planned ({formatDuration(plannedTotal)})</span>
                      </div>
                    )}
                    {unplanned.length > 0 && (
                      <div style={{ width: `${unplannedNormPct}%`, textAlign: "center", fontSize: "0.85rem", fontWeight: 700, color: "#c62828", padding: "4px 0", overflow: "hidden", boxSizing: "border-box" }}>
                        <div style={{ borderTop: "3px solid #c62828", marginLeft: 2, marginRight: 2, marginBottom: 4 }} />
                        <span>Unplanned ({formatDuration(unplannedTotal)})</span>
                      </div>
                    )}
                  </div>
                  )}
                  {/* Tables */}
                  <div style={{ display: "flex", gap: 16, marginTop: 8, flexWrap: "wrap" }}>
                    {sortedPlanned.length > 0 && (
                      <div style={{ flex: 1, minWidth: 250 }}>
                        <div style={{ fontSize: "1.05rem", fontWeight: 700, color: "#2e7d32", marginBottom: 6, paddingLeft: 4 }}>Planned Downtime</div>
                        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.95rem" }}>
                          <thead>
                            <tr style={{ background: "#f5f5f5" }}>
                              <th style={{ padding: "6px 10px", textAlign: "left", borderBottom: "2px solid #2e7d32", fontWeight: 700 }}>Reason</th>
                              <th style={{ padding: "6px 10px", textAlign: "right", borderBottom: "2px solid #2e7d32", fontWeight: 700 }}>Duration</th>
                            </tr>
                          </thead>
                          <tbody>
                            {sortedPlanned.map((p, i) => (
                              <tr key={i} style={{ borderBottom: "1px solid #eee" }}>
                                <td style={{ padding: "6px 10px", display: "flex", alignItems: "center", gap: 8 }}>
                                  <div style={{ width: 10, height: 10, borderRadius: 2, background: p.Color || "#2e7d32", flexShrink: 0 }} />
                                  {p.Category}
                                </td>
                                <td style={{ padding: "6px 10px", textAlign: "right", fontWeight: 600 }}>{formatDuration(p.Duration)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                    {sortedUnplanned.length > 0 && (
                      <div style={{ flex: 1, minWidth: 250 }}>
                        <div style={{ fontSize: "1.05rem", fontWeight: 700, color: "#c62828", marginBottom: 6, paddingLeft: 4 }}>Unplanned Downtime</div>
                        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.95rem" }}>
                          <thead>
                            <tr style={{ background: "#f5f5f5" }}>
                              <th style={{ padding: "6px 10px", textAlign: "left", borderBottom: "2px solid #c62828", fontWeight: 700 }}>Reason</th>
                              <th style={{ padding: "6px 10px", textAlign: "right", borderBottom: "2px solid #c62828", fontWeight: 700 }}>Duration</th>
                            </tr>
                          </thead>
                          <tbody>
                            {sortedUnplanned.map((u, i) => (
                              <tr key={i} style={{ borderBottom: "1px solid #eee" }}>
                                <td style={{ padding: "6px 10px", display: "flex", alignItems: "center", gap: 8 }}>
                                  <div style={{ width: 10, height: 10, borderRadius: 2, background: u.Color || "#c62828", flexShrink: 0 }} />
                                  {u.Category}
                                </td>
                                <td style={{ padding: "6px 10px", textAlign: "right", fontWeight: 600 }}>{formatDuration(u.Duration)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </div>
              );
            })()}
          </div>
        </div>
      )}
      <div className="row ml-0">
        {equipmentColor.EquipmentColor.map((x) => {
          return (
            <div
              style={{ background: `${x.Color}` }}
              className="grid-item shadow card col-lg-1 col-sm-1 col-xl-1 p-1 m-1 "
            >
              <div className="d-flex flex-column ">
                <div style={{ fontSize: "1.5vw", fontWeight: "700" }}>
                  {x.Equipment}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="row ml-0 mt-3 mb-2" style={{ padding: "8px 12px", background: "#f8f9fa", borderRadius: 5, fontSize: "14px" }}>
        <div className="col-12">
          <strong>Note:</strong> The color of each machine card indicates its current operational status.
          <div className="d-flex flex-wrap mt-1" style={{ gap: "15px" }}>
            <div className="d-flex align-items-center">
              <div style={{ width: 12, height: 12, background: "green", borderRadius: 3, marginRight: 5 }}></div>
              <span><strong>Green</strong>- Machine is currently Running and producing parts</span>
            </div>
            <div className="d-flex align-items-center">
              <div style={{ width: 12, height: 12, background: "yellow", borderRadius: 3, marginRight: 5 }}></div>
              <span><strong>Yellow</strong> - Machine is on Break or Down for less than 30 minutes</span>
            </div>
            <div className="d-flex align-items-center">
              <div style={{ width: 12, height: 12, background: "red", borderRadius: 3, marginRight: 5 }}></div>
              <span><strong>Red</strong> - Machine is on Break or Down for 30 minutes or more</span>
            </div>
            <div className="d-flex align-items-center">
              <div style={{ width: 12, height: 12, background: "grey", borderRadius: 3, marginRight: 5 }}></div>
              <span><strong>Grey</strong> - No data available for this machine in the current shift</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashBoardCustom;